import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import axios from "axios";
import { getRootComponent } from "../../utilities/ElementUtils";
import { apiUrl } from "../../config";
import { getEnvVar } from "../../config/RuntimeConfig";

interface Props {
    field: FormSectionElements;
    editable: boolean;
    title;
    labelControlArray;
    requiredField;
    callbackElement;
    isEng: boolean;
}

interface State {
  input: string;
  touched: boolean;
}


export class BusinessNumberComponent extends React.Component<Props, State> {
   
  
    constructor(props: Props) {
        super(props);

        let field = this.props.field;
        FormValidationUtils.runJavascript(field);

        this.state = {
          input: props.field.Value || '',
          touched: false,
        };
    }
    
    valueLength(value) {
      if (typeof value == 'string') {
        return value.length;
      }
      return 0;
    }

    render() {
        let field =  this.props.field;
  
        let  editable = this.props.editable;
        let labelControlArray =this.props.labelControlArray;
        let requiredField =this.props.requiredField;
        let controlArray = [];
        let title = this.props.title;
        let hintHtml = this.props.isEng ? field.Hint : field.HintFR;

   const requiredLabel = this.props.field.Optional == "N" ? (this.props.isEng   ? "(required)"   : "(obligatoire)" ) : this.props.isEng ? "(optional)" : "(facultatif)"
        const programContainer = getRootComponent(field);
        if (editable) {
          controlArray.push(
            <div key={'div_' + field.Datatype +'_' + field.Id} id= {'div_' + field.Datatype +'_' + field.Id}>

              <div key={'fdLbl_div_' + field.Id} >
                {labelControlArray}
              </div>
              <div>
              <LiveValidationErrMsg
                             field={this.props.field}
                            isEng={this.props.isEng}
                            key={"LiveValidationErrMsg_" +this.props.field.LoadBindName} />

              </div>
              <div key={'fdIpt_div_' + field.Id} >
                <div>
                  <input className={this.props.field.Valid || !this.props.field.Touched?'ontario-input form-input-width-medium':'ontario-input ontario-input__error'} id={field.LoadBindName}  key={'fdIpt_' + field.Id} 
                    value={this.state.input} readOnly={field.ReadOnly}
                    aria-required={field.Optional !== 'Y'}                
                    aria-describedby={
                      [!field.Valid && `${field.LoadBindName}-${field.Id}-error`, hintHtml && `hint-text-${field.LoadBindName}`]
                        .filter(Boolean)
                        .join(' ') || undefined
                    }                    aria-invalid={!field.Valid ||field.Touched ? true : undefined}
                    onChange={(e) => {
                      field.Valid = true;
                      let val = e.target.value;
                      this.setState({
                        input: val == null? null: val.toUpperCase(),
                        touched: true,
                      });
                    }}

                    onBlur = {() => {
                      const { field } = this.props;

                      field.Value = this.state.input;
                      field.Touched = this.state.touched;

                      FormValidationUtils.validateBusinessNumber(field)
                      FormValidationUtils.runJavascript(field);

                      if(field.Valid && !field.IsEmpty) {
                        const url = getEnvVar('TPON_BD_URL')?.replace("{{bn9}}", field.Value).replace("{{ownership}}", "Corporation").replace("{{language}}", this.props.isEng?"en":"fr");
               
                        let postObject = {
                          url: url,
                          httpMethod: "GET",
                          payload: null
                      };
                     axios.post(apiUrl() + "/tponTransfer", postObject)
                     .then(response => {
                         console.log(response.data);
                        })
                        .catch(error => {
                          console.error('Error:', error);
                        });
                      }

                      this.props.callbackElement(getRootComponent(this.props.field));
                    }
                    } />
                </div>
              </div>
            </div>);
        } else {
          controlArray.push(
            <div
              key={'div_' + field.Datatype + '_' + field.Id}
              className={programContainer.isHorizontalLayout ? 'pdf-row-column' : 'pdf-two-column'}
            >
              <div>{title}</div>
              <div className={classNames({ 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })} >{this.props.field.Value}</div>
            </div>
          );
        }

        return controlArray;
    }

}